<template>
    <div class="widget wrapper" :style="{'grid-area':area}">
        <h4>{{title}}</h4>
        <div class="extras">
            <slot name="extras"></slot>
            <el-popover>
                <template>
                    <div>Help</div>
                    <button class="head-button" slot="reference">
                        <font-awesome-icon class="help-icon" icon="question"/>
                    </button>
                </template>
            </el-popover>
        </div>
        <div v-if="scrollable" v-bar="{preventParentScroll: true}">
            <div>
                <slot>
                    <div>No Data</div>
                </slot>
            </div>
        </div>
        <div v-else>
            <slot>
                <div>No Data</div>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            area: String,
            scrollable: false
        }
    }
</script>

<style lang="scss" scoped>
    h4 {
        text-align: center;
        margin: .5em 1em .5em .5em;
        color: white;
    }

    .wrapper {
        line-height: 1.3em;
        color: #cdd4e1;
        font-size: 1rem;
        border-radius: 5px;
        border: 1px solid rgba(163, 163, 172, 0.2);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
        background: linear-gradient(#3f3f46, #303036);
        padding-left: .5em;
        padding-bottom: 1.2em;
        position: relative;
    }

    .extras {
        opacity: 0.2;
        transition: all 200ms linear;

        position: absolute;
        right: 6px;
        top: 6px;

    }

    .wrapper:hover {
        .extras {
            opacity: 1;
        }
    }
</style>
<style lang="scss">
    .widget .vb {
        height: calc(100% - 25px);
    }

    .head-button {
        border: none;
        background: none;
        text-shadow: 1px 1px 1px #000;
        color: rgba(200, 200, 200, 0.8);
        cursor: pointer;
        opacity: .5;
        transition: all 200ms linear;

        &:hover {
            opacity: 1;
        }
    }
    .help-icon {
        font-size: 14px;
    }
</style>
